import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { sizeKeys, sizes, typeKeys, types } from './config';
import { getType } from './lib';
import styles from './Btn.module.scss';

const Btn = ({
  type: externalType,
  size: externalSize,
  className,
  ...props
}) => {
  const isLink = Boolean(props.to);

  const Component = isLink ? Link : Button;

  const type = types.has(externalType) ? externalType : typeKeys.primary;
  const size = sizes.has(externalSize) ? externalSize : sizeKeys.lg;

  const componentProps = {
    className: cn(className, styles.root),
    ...props,
  };

  if (isLink) {
    componentProps.type = getType(type);
  }

  return (
    <Component
      {...componentProps}
      data-type={type}
      data-size={size}
    />
  );
};

export default Btn;
